import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConfigure = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_1857_3763",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_1857_3763)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.70825 16.7917V12.2083H10.7916V13.9583H16.7916V15.0417H10.7916V16.7917H9.70825ZM3.20825 15.0417V13.9583H7.79159V15.0417H3.20825ZM6.20825 12.2917V10.5417H3.20825V9.45834H6.20825V7.70834H7.29159V12.2917H6.20825ZM9.20825 10.5417V9.45834H16.7916V10.5417H9.20825ZM12.2083 7.79168V3.20834H13.2916V4.95834H16.7916V6.04168H13.2916V7.79168H12.2083ZM3.20825 6.04168V4.95834H10.7916V6.04168H3.20825Z",
			fill: "currentColor"
		})
	})]
});
export default SvgConfigure;
